var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0919 10.6386C11.8894 10.5024 11.644 10.445 11.402 10.4772C11.2622 10.4958 11.1165 10.5099 10.9649 10.5194C10.9206 10.889 10.8349 11.2263 10.7115 11.5309C10.9979 11.5241 11.2722 11.5032 11.5339 11.4684L13.6441 12.8875C13.9898 13.1201 14.4535 12.8773 14.4352 12.4734L14.3245 10.0343C14.7641 9.44732 15.0001 8.69007 15.0001 7.76644C15.0001 5.28068 13.2901 3.99999 10.5001 4C8.42849 4 6.88672 4.75389 6.28125 6.22779C4.22954 6.45605 2.99997 7.70165 3 9.91024C2.99999 10.823 3.20988 11.5712 3.60095 12.1512L3.50688 14.4538C3.48935 14.8827 3.95691 15.1547 4.28727 14.9078L6.08083 13.5673C6.3701 13.6101 6.6769 13.6316 7 13.6316C9.40002 13.6316 11 12.3664 11 9.91078C11 7.55606 9.52946 6.29598 7.29322 6.19592C7.33701 6.19788 7.3805 6.20028 7.4237 6.20313C7.54818 6.02088 7.69629 5.86497 7.86283 5.73153C8.41639 5.28801 9.29246 5 10.5001 5C11.7595 5 12.6291 5.29099 13.1656 5.72708C13.6701 6.13709 14.0001 6.7718 14.0001 7.76643V7.76646C14.0001 8.51604 13.811 9.05176 13.5241 9.43487C13.3852 9.62032 13.315 9.84824 13.3255 10.0797L13.3905 11.5119L12.0919 10.6386ZM6.22714 12.5781C5.96365 12.5391 5.69551 12.6069 5.48217 12.7663L4.54813 13.4644L4.60011 12.192C4.60881 11.9791 4.54924 11.7689 4.43008 11.5922C4.17384 11.2121 3.99999 10.6703 4 9.91025V9.91023C3.99999 8.89529 4.30706 8.26239 4.74028 7.87108C5.18966 7.46518 5.91857 7.18945 7 7.18945C8.03438 7.18945 8.76994 7.46177 9.23501 7.87588C9.68259 8.27443 10 8.91076 10 9.91077V9.9108C10 10.9105 9.68263 11.5467 9.23505 11.9452C8.76997 12.3593 8.03437 12.6316 7 12.6316C6.72094 12.6316 6.46332 12.613 6.22714 12.5781Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.8029a664a86cfb1524b8bc6596353bea.svg";